import baseAPI from '@/api/base';
import { DASHBOARD_URL } from '@/utils/urls';
import { AxiosResponse } from 'axios';

export interface GetDashboard {
  /** today, 7d, 30d or 90d — see utils/dashboard. */
  range: string;
  /** The viewer's IANA time zone, so the server's days are their days. */
  tz: string;
}

class Dashboard {
  static getDashboard = async (params: GetDashboard): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(DASHBOARD_URL, { params });
    return response;
  };
}

export default Dashboard;
